import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=2478b1b2&scoped=true&"
import script from "./ProjectCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreate.vue?vue&type=style&index=0&id=2478b1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478b1b2",
  null
  
)

component.options.__file = "ProjectCreate.vue"
export default component.exports